import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

import Header from './shared/components/header';
import Footer from './shared/components/footer';

import Home from './general/pages/home';
import Search from './general/pages/search';
import Details from './general/pages/details';
import Favorites from './general/pages/favorites';

import Login from './user/pages/login';
import Register from './user/pages/register';
import Profile from './user/pages/profile';
import ForgotPass from './user/pages/forgotPass';

import './shared/styles/toast.css';

export default function App() {
  return (
    <div className="app-layout">
      <Router>
        <Toaster position="top-center" />

        <Header />

        <main className="app-main">
          <Switch>
            <Route path="/" exact>
              <Home />
            </Route>
            <Route path="/buscar" exact>
              <Search />
            </Route>
            <Route path="/detalles/:id" exact>
              <Details />
            </Route>
            <Route path="/favoritos" exact>
              <Favorites />
            </Route>
            <Route path="/login" exact>
              <Login />
            </Route>
            <Route path="/registro" exact>
              <Register />
            </Route>
            <Route path="/perfil" exact>
              <Profile />
            </Route>
            <Route path="/forgotPass" exact>
              <ForgotPass />
            </Route>
            <Redirect to="/" />
          </Switch>
        </main>

        <Footer />
      </Router>
    </div>
  );
}